import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { HttpErrorHandler, HandleError } from './http-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private _logging = environment.logging;
  private _apiSettings = environment.restAPI;
  private _baseServiceUrl = '';
  private _handleError: HandleError;

  constructor(@Inject('BASE_URL') baseUrl: string, private _httpClient: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this._baseServiceUrl = (this._apiSettings.useStaticUrl ? this._apiSettings.staticUrl : baseUrl) + this._apiSettings.urlSuffix;
    this._handleError = httpErrorHandler.createHandleError('SessionService');
  }

  clearSession() {
    sessionStorage.clear();
  }

  removeValueFromSession(key: string) {
    if (key !== undefined && key !== null && key.length > 0) {
      sessionStorage.removeItem(key);
    }
  }

  getStringValueFromSession(key: string): string {
    if (key !== undefined && key !== null && key.length > 0) {
      return sessionStorage.getItem(key);
    } else {
      return null;
    }
  }

  setStringValueToSession(key: string, value: string) {
    if (key !== undefined && key !== null && key.length > 0) {
      const val: string = value !== undefined ? value : null;
      sessionStorage.setItem(key, val);
    }
  }

  getNumberValueFromSession(key: string): number {
    if (key !== undefined && key !== null && key.length > 0) {
      return Number(sessionStorage.getItem(key)) || null;
    } else {
      return null;
    }
  }

  setNumberValueToSession(key: string, value: number) {
    if (key !== undefined && key !== null && key.length > 0) {
      const val: string = value !== undefined && value !== null ? value.toString() : null;
      sessionStorage.setItem(key, val);
    }
  }

  getBooleanValueFromSession(key: string): boolean {
    if (key !== undefined && key !== null && key.length > 0) {
      const val: string = sessionStorage.getItem(key);
      return val !== undefined && val !== null && val.length > 0 ? val.toLowerCase() === 'true' : null;
    } else {
      return null;
    }
  }

  setBooleanValueToSession(key: string, value: boolean) {
    if (key !== undefined && key !== null && key.length > 0) {
      const val: string = value !== undefined && value !== null ? (value ? 'true' : 'false') : null;
      sessionStorage.setItem(key, val);
    }
  }

  getObjectFromSession(key: string): any {
    if (key !== undefined && key !== null && key.length > 0) {
      return JSON.parse(sessionStorage.getItem(key)) || null;
    } else {
      return null;
    }
  }

  setObjectToSession(key: string, value: any) {
    if (key !== undefined && key !== null && key.length > 0) {
      const val: string = value !== undefined && value !== null ? JSON.stringify(value) : null;
      sessionStorage.setItem(key, val);
    }
  }
}
